import { SmartTagRemovalOperations } from './SmartTagRemovalOperations';
import { SmartTagResetOperations } from './SmartTagResetOperations';
export class SmartTagTagOperations {
    #removalOps;
    #resetOps;
    constructor(deps) {
        this.#removalOps = new SmartTagRemovalOperations(deps);
        this.#resetOps = new SmartTagResetOperations(deps);
    }
    removeTag = (tag) => this.#removalOps.removeTag(tag);
    resetTags = () => this.#resetOps.resetTags();
}
